export default __webpack_public_path__ + "static/media/pencil-icon.765b1078.svg";